import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Row, Col, Spinner } from 'reactstrap';
import { GoogleMap} from './GoogleMap';
import { Preview } from './Preview';
import { Fade} from '@progress/kendo-react-animation';
import ReactGA from 'react-ga';

@inject("mobxStore")
@observer
export class LandListings extends Component {

  constructor (props) {
    super(props);
    props.mobxStore.getLandPres();

    this.state = {
        activeTab: '1'
    };
  }
  componentDidMount() {
    ReactGA.set({ page: 'LandListing' });
    ReactGA.pageview('/land');
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
        this.setState({
            activeTab: tab
        });
    }
  }

  classnames = (active) => {
      return active ? "active" : "";
  }

  render () {
    const {landPres} = this.props.mobxStore;

    return (
        <div className="container residentialPre">
            <div className="pt-4 text-center">
                <img className="d-inline" alt="Residential" src="/images/land_small.png"/>
                <h4 className="d-inline-block ml-3" style={{color: '#333333'}}>Land Listings</h4>
            </div>
            <div>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={this.classnames(this.state.activeTab === '1')}
                            onClick={() => { this.toggle('1'); }}>
                            Gallery View
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={this.classnames(this.state.activeTab === '2')}
                            onClick={() => { this.toggle('2'); }}>
                            Map View
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                        { landPres &&
                            <Fade appear={true}>
                                <ul className="row multi-columns-row pt-3">
                                    { landPres.map((l, index) =>
                                        (<li key={index} className="col-sm-6 col-md-4 col-lg-4 mb-2">
                                            <Card body>
                                                <Preview listing={l} featured={false}></Preview>
                                            </Card>
                                        </li>
                                        ))
                                    }
                                </ul>
                            </Fade>
                        }
                        { !landPres &&
                            <Spinner size="lg"/>
                        }
                    </TabPane>
                    <TabPane tabId="2">
                        <Row>
                            <Col sm="12">
                                <GoogleMap properties={landPres} history={this.props.history}></GoogleMap>
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LandListings.jsx